export default {
    default: {
        color: 'neutral_8',
        '&:hover': {
            bg: 'neutral_1',
        },
    },
    primary: {
        color: 'primary_2',
        '&:hover': {
            bg: 'neutral_1',
            color: 'primary_1',
            '&.active': {
                bg: 'primary_1',
                color: 'neutral_0',
            },
        },
    },
};
